import React, { useEffect, useState } from 'react';
import { IonContent, IonPage, IonCol, IonRow } from '@ionic/react';
import AppHeader from '../components/AppHeader';
import NewsCard from '../components/NewsCard';
import Post from '../models/Post';
import PostRepository from '../repositories/PostRepository';

const News: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    async function fetchSlots() {
      setIsLoading(true);
      setPosts(await PostRepository.findAll());
      setIsLoading(false);
    }

    fetchSlots();
  }, []);

  return (
    <IonPage>
      <AppHeader />
      <IonContent>
        <div className="wrapper wrapper--large ion-padding">
          <h2>Actualités</h2>
          <IonRow>
            {isLoading ? (
              <IonCol size="12" sizeLg="6">
                <NewsCard />
              </IonCol>
            ) : (
              posts.map((post) => (
                <IonCol size="12" sizeLg="6" key={post.id}>
                  <NewsCard post={post} />
                </IonCol>
              ))
            )}
          </IonRow>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default News;
